/* OBJECTS */
import $ from 'jquery';
export default class Mobile {
  constructor () {}
  menu_action = () => {
    $('body').on('click', 'a.mobile_caller', function (event) {
      event.preventDefault();
      $('body').toggleClass('mobile-menu-opened');
      $(this).toggleClass('open');
    });
    $('body').on('click', 'a.mobile_search_caller', function (event) {
      event.preventDefault();
      $('body').toggleClass('mobile-search-opened');
      $(this).toggleClass('open');
    });
    $('body').on('click', '.mobile-navigation-place .close', function (event) {
      event.preventDefault();
      $('body').toggleClass('mobile-menu-opened');
      $(this).toggleClass('open');
    });
    $(window).on('resize', function (event) {
      if ($(window).width() > 768) {
        if ($('body').hasClass('mobile-search-opened')) {
          $('body').removeClass('mobile-search-opened');
        }
        if ($('body').hasClass('mobile-menu-opened')) {
          $('body').removeClass('mobile-menu-opened');
        }
        if ($('.mobile_caller').hasClass('open')) {
          $('.mobile_caller').removeClass('open');
        }
      }
    });
  }
  buildMobile = json => {
    $.each(json, function (i, structure) {
      $.each(structure[0]['before_content'], function (i, element) {
        $(element).addClass('hide_if_mobile');
        $(element)
          .clone()
          .removeClass('hide_if_mobile')
          .addClass('cloned')
          .appendTo(structure[0]['place']);
      });
      $.each(structure[0]['content'], function (i, element) {
        var clone = $(element).clone();
        $(element).addClass('hide_if_mobile');

        clone
          .find('li>ul')
          .parent()
          .addClass('has-submenu')
          .find('>a')
          .append(
            '<span class="mobile-toggle"><i class="fa fa-angle-down"></i></span>'
          );
        clone.find('.has-submenu>ul>li>a').prepend('<span class="pre">-</span>');
        clone
          .removeClass('hide_if_mobile')
          .addClass('cloned')
          .appendTo(structure[0]['place']);
      });
      $.each(structure[0]['after_content'], function (i, element) {
        $(element).addClass('hide_if_mobile');
        $(element)
          .clone()
          .removeClass('hide_if_mobile')
          .addClass('cloned')
          .appendTo(structure[0]['place']);
      });
    });
  }
  init = () => {
    var mobile_data = {
      mob_nav: [
        {
          place: '.mobile-navigation-place',
          class: 'mob_nav_header',
          before_content: ['.mobile-comps .header'],
          after_content: [
            '.mobile-comps .buttons',
            '.social-menu',
            '.mobile-comps .footer',
            '.footer-menu'
          ],
          content: ['.menu']
        }
      ]
    };
    this.buildMobile(mobile_data);
    this.menu_action();
  }
}
